import BaseSource, { AVAILABLE_COLLECTION_TYPES } from 'sources/baseSource';
import Staff from 'types/Staff';
import SourceStaffType from 'sources/sourceTypes/Staff';
import * as mapper from 'sources/mapper/Staff';
import { PaginationParams } from 'sources/sourceTypes/Pagination';

export interface StaffParams extends PaginationParams {
  ids?: number[];
  eventIds?: number[];
  sessionIds?: string[];
  statuses?: string[];
}

class StaffSource extends BaseSource<Staff, SourceStaffType, StaffParams> {
  public ObjectURL = 'staff' as AVAILABLE_COLLECTION_TYPES;

  public toSource = mapper.toSource;

  public toType = mapper.toType;
}

const staffSource = new StaffSource();

export default staffSource;
